import React, { useState } from "react";
import { Row, Col, Button, Modal } from "antd";
import "./SellPropertySection.css";
import {
  CheckCircleOutlined,
  TeamOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import { useHistory } from "react-router-dom";

const SellPropertySection = () => {
  const history = useHistory();
  const { isSuperLarge } = useBreakpoints();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Row
        justify="center"
        className="sell-property-section"
      >
        <Col
          xs={22}
          sm={22}
          md={22}
          lg={18}
          xl={20}
          xxl={16}
          style={{ maxWidth: isSuperLarge ? "50%" : "" }}
        >
          <Row gutter={[32, 32]} align="middle">
            {/* LEFT CONTENT */}
            <Col xs={24} md={14}>
              <h2 className="sell-heading">
                Looking to Sell Your Property?
              </h2>

              <p className="sell-subheading">
                Get the right valuation, connect with genuine buyers,
                and experience a smooth closure with Realty Vibes.
              </p>

              <div className="sell-points">
                <div className="sell-point">
                  <CheckCircleOutlined />
                  <span>Market-accurate property valuation</span>
                </div>
                <div className="sell-point">
                  <TeamOutlined />
                  <span>Access to verified buyer network</span>
                </div>
                <div className="sell-point">
                  <FileDoneOutlined />
                  <span>Complete documentation support</span>
                </div>
              </div>

              <Button
                className="sell-cta-btn"
                onClick={(e) => {
                 
                  history.push("/post");
                }}
              >
                List My Property
              </Button>
            </Col>

            {/* RIGHT STATS CARD */}
            <Col xs={24} md={10}>
              <div className="sell-stats-card">
                <div className="sell-stats-main">
                  <h3>200+</h3>
                  <p>Properties Sold</p>
                </div>

                <div className="sell-stats-bottom">
                  <div className="sell-stat-box">
                    <h4>₹500Cr+</h4>
                    <p>Transaction Value</p>
                  </div>
                  <div className="sell-stat-box">
                    <h4>45 Days</h4>
                    <p>Avg. Closing Time</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* MODAL (EMPTY FOR NOW) */}
      <Modal
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        width={600}
      >
        {/* You will give fields later */}
      </Modal>
    </>
  );
};

export default SellPropertySection;
